import { createFileRoute } from '@tanstack/react-router'

import { ProfileSettingsPage } from '@/pages/settings/profile/ProfileSettingsPage'

export const Route = createFileRoute('/_authenticated/_dashboard/settings/profile/')({
  component: ProfileSettingsPage,
})
